import * as Headless from '@headlessui/react';
import cn from '@/utils/cn';

type TProps = {
  className?: string;
} & Omit<Headless.FieldsetProps, 'as' | 'className'>;

export const Fieldset = ({ className, ...props }: TProps) => {
  return (
    <Headless.Fieldset
      {...props}
      className={cn(
        className,
        '*:data-[slot=text]:mt-1 [&>*+[data-slot=control]]:mt-6'
      )}
    />
  );
};
